<template>
  <div class="app">
    <div class="banner">
      <img :src="object.banner" alt="">
    </div>
    <div class="content content1">
      <nav>{{object.jqmc}}</nav>
      <div class="content1-center">
        <p>{{object.jqjb}}景区</p>
        <img src="@assets/images/banner/phone.png" alt="" @click="clickPhone">
      </div>
      <div class="content1-nr">
        <img src="@assets/images/banner/addres.png" alt="">
        <p>{{object.address}}</p>
        <span @click="goMap(item)">地图 ></span>
      </div>
    </div>
    <div class="content content2">
      <div class="nav">景区图片</div>
      <div class="content2-nr">
        <img v-for="(item,index) in object.jqtpArry" :key="index" :src="item" alt="">
      </div>
    </div>
    <div class="content content2">
      <div class="nav">景区简介</div>
      <div class="content2-nr">
      <div v-html="object.jqjj"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import { ImagePreview } from 'vant'
import { addRandomAndGetPreviewImageUrlsFromRichText } from '@/utils/util'
export default {
  data() {
    return {
      downOption: {
        auto: false //是否在初始化后,自动执行downCallback; 默认true
      },
      title: '通知公告',
      params: this.$route.query,
      object: {},
      richImages: [],
      html: ''
    }
  },
  created() {},
  mounted() {
    // console.log('详情', this.$store.state.wallView)
    // this.object = this.$store.state.wallView
    this.params = this.$route.query
    this.getData()
  },
  methods: {
    previewImage(e) {
      if (e.target.tagName == 'IMG') {
        ImagePreview({
          images: this.richImages,
          startPosition: e.target.src.split('random=')[1] - 1,
          closeOnPopstate: true //页面回退关闭预览
        })
      }
    },
    getData() {
      let params = { 
        id: this.params.id 
      }
      getAction('/zhshj/hmfwlyjqzs/page', params).then(res => {
        let data = res.result.records[0];
        data.jqtpArry = data.jqtp.split(',')
        data.banner = data.jqtpArry[0]
        this.object = data
        console.log("详情",this.object);
        // [this.html, this.richImages] = addRandomAndGetPreviewImageUrlsFromRichText(this.object.jqjj)
      })
    },
    goMap() {
      let mapDate = {}
      mapDate.lat = this.object.latitude
      mapDate.lng = this.object.longitude
      mapDate.address = this.object.address
      mapDate.name = this.object.jqmc
      this.$store.state.mapDate = mapDate
      console.log("地图数据",this.$store.state.mapDate)
      let params={mapDate}
      this.$router.push({
          path:"/common/map",
          params:params
        })
    },
    preViewImg(img) {
      let arr = [img]
      ImagePreview(arr)
    },
    clickPhone(){
      window.location.href=`tel:${this.object.jqdh}`
    }
  }
}
</script>

<style lang="less" scoped>
img{
  max-width: 100%;
  height: auto;
}
.app /deep/ img{
  max-width: 100%;
  max-height: 400px;
}
.app{
  width: 100%;
	height: 100vh;
	background-color: #f6f7f9;
}
.banner{
  width: 100%;
}
.content{
  width: 100%;
  padding: 14px;
  position: relative;
  z-index: 99;
  box-sizing: border-box;
  border-radius: 10px;
  background: white;
}
.content1{
  margin: -30px 0px 20px;
  nav{
    font-family: PingFangSC-Medium;
    letter-spacing: 0.29px;
    font-weight: 500;
  }
  &-center{
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(153, 153, 153, .1); 
    justify-content: space-between;
    margin-bottom: 15px;
    p{
      font-size: 14px;
      color: white;
      padding: 2px 10px;
      background-image: linear-gradient(90deg, #64BDFF 0%, #168DFD 100%);
      border-radius: 3px;
      margin: 10px 0px;
    }
    img{
      height: 18px;
    }
  }
  &-nr{
    display: flex;
    align-items: center;
    background: #F4F5F9;
    border-radius: 3px;
    padding: 10px 10px;
    font-size: 13px;
    justify-content: space-between;
    img{
      height: 16px;
    }
    p{
      width: 80%;
      color: #6C6B71;
    }
    span{
      color: #226DDF;
    }
  }
}
.content2{
  .nav{
    font-family: PingFangSC-Medium;
    letter-spacing: 0.29px;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
  .nav::before{
    content:"";
    width: 2px;
    height: 16px;
    display: block;
    margin: 0px 4px 0px 0px;
    background: #006FE7;
    border-radius: 2px;
  }
  &-nr{
    display: flex;
    width: 100%;
    overflow: hidden;
    overflow-x: auto;
    margin: 10px 0px;
    img{
      max-height: 100px;
      margin-right: 10px;
    }
  }
}
</style>
